<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Menu from '../../../../RightMenu.svelte';
  import MenuOption from '../../../../RightMenuOption.svelte';

  const dispatch = createEventDispatcher();

  export let showMenu = false;
  export let previewMode = false;
  export let pos: { x: number; y: number } = { x: 0, y: 0 };
  export let quickSigns: any[] = [];
  export let blog: { siteurl: string } = { siteurl: '' };
  export let entry_requireds: any[] = [];
  export let entry_options: any[] = [];

  function closeMenu() {
    dispatch('close');
  }

  function addSignImage() {
    dispatch('addSignImage', { position: 1 });
  }

  function addQuickSignImage(image: string) {
    dispatch('addQuickSignImage', { url: blog.siteurl + image, position: 1 });
  }

  function addTextField(text: string) {
    dispatch('addTextField', { text, positioned: true });
  }
</script>

{#if showMenu && !previewMode}
  <Menu {...pos} on:click={closeMenu} on:clickoutside={closeMenu}>
    <MenuOption on:click={addSignImage} text="Get Signature" menutype="parent" />
    <MenuOption text="Saved Signatures" />
    {#each quickSigns as sign}
      <MenuOption
        on:click={() => addQuickSignImage(sign.image)}
        text={sign.name}
        menutype="sub"
      />
    {/each}
    <MenuOption on:click={() => addTextField('Initial')} text="Initial" menutype="parent" />
    <MenuOption on:click={() => addTextField('Date')} text="Date" menutype="parent" />
    <MenuOption on:click={() => addTextField('Name')} text="Name" menutype="parent" />
    <MenuOption on:click={() => addTextField('Phone_Number')} text="Phone" menutype="parent" />
    <MenuOption on:click={() => addTextField('New Text Field')} text="Text" menutype="parent" />
    <div class="has_sub_menu">
      <MenuOption on:click={() => addTextField('Entry Required')} text="Entry(required)" menutype="parent" />
      {#each entry_requireds as object}
        <MenuOption
          on:click={() => addTextField(object.text)}
          text={object.lines[0]}
          menutype="sub"
        />
      {/each}
    </div>
    <div class="has_sub_menu">
      <MenuOption on:click={() => addTextField('Entry Optional')} text="Entry(optional)" menutype="parent" />
      {#each entry_options as object}
        <MenuOption
          on:click={() => addTextField(object.text)}
          text={object.lines[0]}
          menutype="sub"
        />
      {/each}
    </div>
  </Menu>
{/if}
